<template>
  <AppDeleteModal
    :show="showConfirmDeleteDialog"
    :title="`${$t('action.delete_entity', {
      entity: $t('dashboard.menu.custom_dashboard').toLowerCase()
    })}`"
    :loading="isLoading"
    keypath="dashboard.delete.message"
    :keyword="KEYWORD"
    @on-confirm="onConfirmDeleteDashboard"
    @on-close="closeConfirmDeleteDialog"
  >
    <template #i18n-t:dashboardName>
      {{ dashboardForDelete.name }}
    </template>

    <template #i18n-t:break>
      <br />
    </template>
  </AppDeleteModal>
</template>

<script setup>
import { computed, ref } from 'vue'
import { useStore } from 'vuex'

import CustomDashboardApiHandler from '@/api/custom-dashboard'
import { trackDeleteCustomDashboardEvent } from '@/tracking/amplitude-helpers'
import { handleError } from '@/utils/error-handling'
import { KEYWORD } from '@/utils/helpers'

import AppDeleteModal from '@/components/ui/AppDeleteModal/AppDeleteModal'

defineOptions({
  name: 'RemoveCustomDashboard'
})

const props = defineProps({
  showConfirmDeleteDialog: {
    type: Boolean
  },

  dashboardForDelete: {
    type: Object,
    default: () => ({})
  }
})
const isLoading = ref(false)

const emit = defineEmits(['close', 'confirm', 'on-success'])

const closeConfirmDeleteDialog = () => {
  emit('close')
}
const store = useStore()
const isPluginAdmin = computed(() => store.state.pluginOptions.isPluginAdmin)
const onConfirmDeleteDashboard = async () => {
  const customDashboardApi = new CustomDashboardApiHandler()
  try {
    const { id } = props.dashboardForDelete
    isLoading.value = true
    await customDashboardApi.deleteDashboard({ id })
    closeConfirmDeleteDialog()
    trackDeleteCustomDashboardEvent({
      id: props.dashboardForDelete.id,
      isPluginAdmin: isPluginAdmin.value
    })
    emit('on-success')
  } catch (error) {
    handleError({ error })
  } finally {
    isLoading.value = false
  }
}
</script>

<style lang="scss" scoped></style>
